{
  "about": "THE MASTER LIST of the website's addresses. web/src/router.ts parses every address with it, and the site's server (server/srweb/routes.py) reads the same file to answer 404 for an address it does not match, so the page a visitor sees and the status a link unfurler or search engine gets cannot disagree. Edit this file, never a copy. In a pattern, the first group is the id. `titles` are the pages' names, for the browser tab and a shared link's preview. The design's /states/<code> is not a State page in v1 (T7): the server redirects it to Support Us, and the website does the same if it is opened there.",
  "pages": {
    "/": "home",
    "/how-this-works": "how",
    "/corrections": "corrections",
    "/who-pays": "pays",
    "/privacy": "privacy",
    "/support": "support",
    "/report": "report"
  },
  "titles": {
    "how": "How this works",
    "corrections": "Corrections",
    "pays": "Who pays for this",
    "privacy": "Privacy",
    "support": "Support Us",
    "report": "Report an error",
    "missing": "Not found"
  },
  "patterns": {
    "term": "^/(\\d{4}-\\d{4})$",
    "item": "^/item/([a-z0-9-]+)$",
    "member": "^/member/([A-Za-z0-9-]+)$",
    "state": "^/states/([A-Za-z]{2})$"
  }
}
